import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./PremiumIcon.scss";
import { faChevronDoubleUp } from "@fortawesome/pro-regular-svg-icons";
import { Placement } from "react-bootstrap/esm/types";
import { OverlayTriggerType } from "react-bootstrap/esm/OverlayTrigger";
import { useTranslation } from "react-i18next";

interface IProps {
    iconOnly?: boolean;
    placement?: Placement;
    trigger?: OverlayTriggerType[];
}

export default function PremiumIcon(props: IProps) {
    const { t } = useTranslation();

    const popover = (
        <Tooltip id={`popover-info-icon`}>
            {props.iconOnly ? t("CommonUI.premiumFeature") : t("CommonUI.premiumDescription")}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            trigger={props.trigger ? props.trigger : ["hover", "focus"]}
            overlay={popover}
            placement={props.placement}
        >
            <div className={`premiumIcon${props.iconOnly ? " iconsOnly" : ""}`}>
                <FontAwesomeIcon icon={faChevronDoubleUp} />
                {!props.iconOnly && t("CommonUI.premiumTitle")}
            </div>
        </OverlayTrigger>
    );
}
